// Vue
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import {Validator} from 'vee-validate';
import Clipboard from 'v-clipboard'
import VModal from 'vue-js-modal';
import * as uiv from 'uiv';
import {parsePhoneNumberFromString} from "libphonenumber-js";
import Alpine from 'alpinejs'

window.Alpine = Alpine;
Alpine.start();

// Validation
const dictionary = {
    en: {
        messages: {
            email: 'Not a valid email',
            required: 'This field is required.',
        }
    }
};

/**
 * validation for a phone number, since the validator does
 */
Validator.extend( 'phone', {
    getMessage(){
        return 'Invalid Phone Number';
    },
    validate( value ){
        let phoneNumber = parsePhoneNumberFromString( value, 'US' );

        return /^\d+$/.test( value ) &&
            _.isString( value ) &&
            !_.isNil( phoneNumber ) &&
            phoneNumber.isValid();
    }
} );

Vue.use( Clipboard );
Vue.use( VeeValidate, {
    locale: 'en',
    dictionary: dictionary
} );
Vue.use( uiv );
Vue.use( VModal, { dialog: true } );

Vue.component( 'addressable', require( './components/Addressable.vue'  ).default);
Vue.component( 'auto-complete', require( './components/AutoComplete.vue'  ).default);
Vue.component( 'admin-notes', require( './components/AdminNotes.vue'  ).default);
Vue.component( 'admin-notes-trans', require( './components/AdminNotesTrans.vue'  ).default);
Vue.component( 'admin-files', require( './components/AdminFiles.vue'  ).default);
Vue.component( 'channel-lineup-preview', require( './components/ChannelLineupPreview.vue'  ).default);
Vue.component( 'color-picker', require( './components/ColorPicker.vue'  ).default);
Vue.component( 'contact', require( './components/Contact.vue'  ).default);
Vue.component( 'dialog-form', require( './components/DialogForm.vue'  ).default);
Vue.component( 'label-type-toggle', require( './components/LabelTypeToggle.vue'  ).default);
Vue.component( 'hidden-string', require( './components/HiddenString.vue'  ).default);
Vue.component( 'multi-select-filter', require( './components/MultiSelectFilter.vue'  ).default);
Vue.component( 'network-access', require( './components/NetworkAccess.vue'  ).default);
Vue.component( 'report', require( './components/Report.vue'  ).default);
Vue.component( 'ssid', require( './components/SSID.vue'  ).default);
Vue.component( 'product', require( './components/Product.vue'  ).default);
Vue.component( 'support-article', require( './components/SupportArticle.vue'  ).default);
Vue.component( 'sort-icon', require( './components/SortIcon.vue'  ).default);
Vue.component( 'task', require( './components/Task.vue'  ).default);
Vue.component( 'collapsable-section', require( './components/CollapsableSection.vue'  ).default);
Vue.component( 'core-billing-ramp-period',require('./components/CoreBillingRampPeriod.vue').default);
Vue.component( 'core-package-price', require( './components/CorePackagePrice.vue'  ).default);
Vue.component( 'core-price-interval', require( './components/CorePriceInterval.vue'  ).default);
Vue.component( 'core-price-interval-all', require( './components/CorePriceIntervalAll.vue'  ).default);
Vue.component( 'core-price-interval-all-by-status', require( './components/CorePriceIntervalAllByStatus.vue'  ).default);
Vue.component( 'core-units', require( './components/CoreUnits.vue'  ).default);
Vue.component( 'core-unit', require( './components/CoreUnit.vue'  ).default);
Vue.component( 'core-communities', require( './components/CoreCommunities.vue'  ).default);
Vue.component( 'amenity-manatee', require('./components/AmenityManatee.vue').default);
Vue.component( 'amenity-manatee-wobble', require('./components/AmenityManateeWobble.vue').default);
Vue.component( 'amenity-manatee-crank', require('./components/AmenityManateeCrank.vue').default);
Vue.component( 'amenity-manatee-loading', require('./components/AmenityManateeLoading.vue').default);
Vue.component( 'tracking-tabs', require( './components/TrackingTabs.vue' ).default);
Vue.component( 'update-cell', require( './components/UpdateCell.vue' ).default);
Vue.component( 'requests', require( './components/Requests.vue' ).default);
Vue.component( 'compensation-request', require( './components/CompensationRequest.vue' ).default);
Vue.component( 'compensation-request-files', require( './components/CompensationRequestFiles.vue' ).default);
Vue.component( 'site-manager', require( './components/SiteManager.vue' ).default);
Vue.component( 'site-manager-credential', require( './components/SiteManagerCredential.vue' ).default);
Vue.component( 'integration-charges', require('./components/IntegrationCharges.vue').default);
Vue.component( 'search', require('./components/Search.vue').default);

const app = new Vue( _.defaults( window.vueApp, {
    el: '#app',
    components: {
        'account': require( './components/Account.vue' ).default,
        'audits': require( './components/Audits.vue' ).default,
        'connect-phone': require( './components/ConnectPhone.vue' ).default,
        'channel-lineup-feature': require( './components/ChannelLineupFeature.vue' ).default,
        'contacts': require( './components/Contacts.vue' ).default,
        'contact-restrictions': require( './components/ContactRestrictions.vue' ).default,
        'email-template-preview': require( './components/EmailTemplatePreview.vue' ).default,
        'install-group': require( './components/InstallGroup.vue' ).default,
        'install-groups': require( './components/InstallGroups.vue' ).default,
        'import-manager': require( './components/ImportManager.vue' ).default,
        'lease': require( './components/Lease.vue' ).default,
        'merchant-account-projects' : require('./components/MerchantAccountProjects.vue').default,
        'nav-phone': require( './components/NavPhone.vue' ).default,
        'network-accesses': require( './components/NetworkAccesses.vue' ).default,
        'network-credential-create': require( './components/NetworkCredentialCreate.vue' ).default,
        'network-credentials-import': require( './components/NetworkCredentialsImport.vue' ).default,
        'network-invites': require( './components/NetworkInvites.vue' ).default,
        'password-block': require( './components/PasswordBlock.vue' ).default,
        'prices': require( './components/Prices.vue' ).default,
        'products': require( './components/Products.vue' ).default,
        'project-enrollment-chart': require( './components/ProjectEnrollmentChart.vue' ).default,
        'project-integrations': require( './components/ProjectIntegrations.vue' ).default,
        'resident': require( './components/Resident.vue' ).default,
        'resident-invitation': require( './components/ResidentInvitation.vue' ).default,
        'reports': require( './components/Reports.vue' ).default,
        'service-subscriptions-import': require( './components/ServiceSubscriptionsImport.vue' ).default,
        'stripe-account-chart': require( './components/StripeAccountChart.vue' ).default,
        'stripe-source-create': require( './components/StripeSourceCreate.vue' ).default,
        'stripe-invoice-create': require( './components/StripeInvoiceCreate.vue' ).default,
        'ssids': require( './components/SSIDs.vue' ).default,
        'support-articles': require( './components/SupportArticles.vue' ).default,
        'tasks': require( './components/Tasks.vue' ).default,
        'tasks-list': require( './components/TasksList.vue' ).default,
        'unit-import': require( './components/UnitImport.vue' ).default,
        'user-profile-file': require( './components/UserProfileFile.vue' ).default,
        'user-create': require( './components/UserCreate.vue' ).default,
        'requests': require( './components/Requests.vue' ).default,
        'compensation-request': require( './components/CompensationRequest.vue' ).default,
        'compensation-request-files': require( './components/CompensationRequestFiles.vue' ).default,
        'site-manager': require( './components/SiteManager.vue' ).default,
        'site-manager-credential': require( './components/SiteManagerCredential.vue' ).default,
        'integration-charges': require( './components/IntegrationCharges.vue' ).default,
    },

    data(){
        return {};
    },

    computed: {
        user(){
            return window._user;
        }
    },

    methods: {
        handleErrors( err ){
            var errors = _.get( err, 'response.data.errors' );
            var message = _.get( err, 'response.data.message', null );

            console.error( err );

            if( _.isObject( errors ) && Object.keys( errors ).length > 0 ){
                _.each( errors, ( messages, errorKey ) => {
                    if( _.isString( messages ) ){
                        this.$notify( {
                            duration: 0,
                            dismissible: true,
                            type: 'danger',
                            placement: 'top-left',
                            title: messages,
                        } );
                    }
                    else if( _.isArray( messages ) ){
                        var errorFields = _.split( errorKey, '.' );

                        if( errorFields.length === 2 ){
                            var errorField = errorFields[ 0 ] + '[' + errorFields[ 1 ] + ']';

                            _.each( messages, ( message ) => {
                                this.errors.add( {
                                    field: errorField,
                                    msg: message
                                } );
                            } );
                        }
                    }
                } );
            }
            else {
                this.$notify( {
                    type: 'danger',
                    placement: 'top-left',
                    title: 'Something went wrong, please refresh your browser and try again',
                } );
            }
        },
    },
} ) );